import * as React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib';
import { DefaultPalette } from '@uifabric/styling/lib/index';
import { IButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

let styles = require('./SkipLinkControl.scss');
let classNames = require('classnames/bind').bind(styles);

/**
 * The state for the skip link control
 */
export interface SkipLinkButtonProps {
    name: string;
    index: number;
    item: HTMLElement;
    shouldAutoFocus: boolean;
    visible: boolean;
    onFocus: (index: number) => void;
    componentRef: (button: IButton, index: number) => void;
}

/**
 * A control for parsing landmark regions on a page and creating skip links to make tabbable shortcut buttons to jump to those regions.
 */
@observer
export default class SkipLinkButton extends React.Component<SkipLinkButtonProps, {}> {
    render() {
        const { name, visible, shouldAutoFocus } = this.props;

        const className = classNames(styles.skipLink, visible && styles.visibleSkipLink);

        const customButtonStyles: IButtonStyles = {
            root: {
                backgroundColor: DefaultPalette.themeDark,
                color: DefaultPalette.white,
            },

            rootHovered: {
                backgroundColor: DefaultPalette.themeDark,
                color: DefaultPalette.white,
            },

            rootPressed: {
                backgroundColor: DefaultPalette.themeDark,
                color: DefaultPalette.white,
            },
        };

        return (
            <DefaultButton
                autoFocus={shouldAutoFocus}
                onClick={this.onButtonClick}
                className={className}
                styles={customButtonStyles}
                componentRef={this.refCallback}
                onFocus={this.onButtonFocus}>
                {name}
            </DefaultButton>
        );
    }

    onButtonFocus = () => {
        const { index, onFocus } = this.props;
        onFocus(index);
    };

    onButtonClick = () => {
        const { item, visible } = this.props;
        if (visible) {
            item.focus();
        }
    };

    refCallback = (button: IButton) => {
        const { index, componentRef } = this.props;
        componentRef(button, index);
    };
}
